import usersApi from '@/api/usersApi.js'

export default {
  namespaced: true,

  state: {
    token: '',
    token_expire_date: '',
    zapier_token: '',
    zapier_token_expire_date: ''
  },

  actions: {
    async storeToken ({ commit }, { expirationDate, type }) {
      const response = await usersApi.storeToken(expirationDate, type)
      if (type === 'account') {
        commit('storeToken', response)
      } else if (type === 'zapier') {
        commit('storeZapierToken', response)
      }
    },

    async deleteToken ({ commit }, type) {
      await usersApi.deleteToken(type)
      if (type === 'account') {
        commit('deleteToken')
      } else if (type === 'zapier') {
        commit('deleteZapierToken')
      }
    },

    async loadToken ({ commit }, type) {
      const response = await usersApi.loadToken(type)
      if (type === 'account') {
        commit('loadToken', response)
      } else if (type === 'zapier') {
        commit('loadZapierToken', response)
      }
    }
  },

  mutations: {
    storeToken (state, response) {
      state.token = response.token
      state.token_expire_date = response.date
    },

    deleteToken (state) {
      state.token = ''
      state.token_expire_date = ''
    },

    storeZapierToken (state, response) {
      state.zapier_token = response.token
      state.zapier_token_expire_date = response.date
    },

    deleteZapierToken (state) {
      state.zapier_token = ''
      state.zapier_token_expire_date = ''
    },

    loadToken (state, response) {
      state.token = response.token
      state.token_expire_date = response.date
    },

    loadZapierToken (state, response) {
      state.zapier_token = response.token
      state.zapier_token_expire_date = response.date
    }
  }
}
